import {BrowserRouter, Route, Routes} from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import './global.css'
import './assets/styles/main.scss'
import Vehicles from './pages/Vehicles'
import PrivateRoute from './components/PrivateRoute'
import Importers from './pages/Importers'
import Store from './context/global_context'
import TatDtcMappings from './pages/vehicles/dtcs/TaTmappings'
import DtcEdit from './pages/vehicles/dtcs/DtcEdit'
import ConnectorViews from './pages/vehicles/connector_views'
import ConnectorViewEdit from './pages/vehicles/connector_views/edit'
import ConnectorViewNew from './pages/vehicles/connector_views/new'
import ConnectorViewEditMappings from './pages/vehicles/connector_views/edit_mappings'
import Administration from './antd/administration'
import EditVehicle from './pages/vehicles/edit'
import CreateNewVehicle from './pages/vehicles/new'
import PowerDistributions from './pages/vehicles/power_distributions'
import Auth from './pages/auth'
import NotPermitted from './pages/not_permitted'
import LogoutSuccess from './pages/logout_success'
import SystemAndSubSystem from './antd/system_and_sub_system'
import InlineConnectionList from './antd/vehicle/inline_connections'
import InlineConnectionStore from './antd/vehicle/inline_connections/context/context'
import ModuleList from './antd/vehicle/modules'
import ModuleStore from './antd/vehicle/modules/context/context'
import DeviceList from './antd/vehicle/devices'
import DeviceStore from './antd/vehicle/devices/context/context'
import InspectionPointsList from './antd/vehicle/inspection_points'
import InspectionPointsStore from './antd/vehicle/inspection_points/context/context'
import ConnectorList from './antd/vehicle/connectors'
import ConnectorStore from './antd/vehicle/connectors/context/context'
import SalesCodeList from './antd/vehicle/sales_code'
import SalesCodeStore from './antd/vehicle/sales_code/context/context'
import WireStore from './antd/wire/context/context'
import WireList from './antd/wire'
import HarnessList from './antd/vehicle/harnesses'
import HarnessStore from './antd/vehicle/harnesses/context/context'
import CircuitList from './antd/vehicle/circuits'
import CircuitStore from './antd/vehicle/circuits/context/context'
import ConnectorViewMappingsPrintPage from './pages/vehicles/connector_views/print'
import NotFound from './pages/404'
import DeviceConnectionList from './antd/vehicle/device_connections'
import DeviceConnectionStore from './antd/vehicle/device_connections/context/context'
import DtcMappingValidationList from './antd/vehicle/dtc_mapping_validation'
import DtcMappingValidationStore from './antd/vehicle/dtc_mapping_validation/context/context'
import GraphMissingImagesList from './antd/vehicle/graph_missing_images'
import GraphMissingImagesStore from './antd/vehicle/graph_missing_images/context/context'
import UsageReport from './antd/usage_report'
import UsageReportStore from './antd/usage_report/context/context'
import PromoteChangesList from './antd/promote_changes'
import PromoteChangesStore from './antd/promote_changes/context/context'
import TracerPreviewPage from './antd/tracer_preview'
import VisualAidList from './antd/vehicle/visual_aid'
import VisualAidStore from './antd/vehicle/visual_aid/context/context'
import VehicleWorkspaceLayout from './antd/vehicle/VehicleWorkspaceLayout'
import {VehicleProvider} from './context/vehicle_context'
import TatStore from './antd/dtcs/TATMappings/context/context'
import DtcsListing from './antd/dtcs/TATMappings/DtcsListing'
import DefPlugin from './antd/plugins/def'
import DefPluginStore from './antd/plugins/def/context/context'
import SalesCodeComplexity from './antd/plugins/sales_code_complexity'
import SalesCodeComplexityStore from './antd/plugins/sales_code_complexity/context/context'
import CapitalHarness from './antd/plugins/capital_harness'
import CapitalHarnessStore from './antd/plugins/capital_harness/context/context'
import VehicleCSVDependencies from './pages/vehicles/csv_dependencies'
import DemoPayload from './pages/vehicles/demo_payload'
import Customer from './antd/administration/customer'
import CustomerStore from './antd/administration/customer/context/context'
import DtcClone from './antd/dtcs/TATMappings/DtcClone'
import DtcAddDependencies from './antd/dtcs/TATMappings/DtcDependencies'
import DtcDependencyStore from './antd/dtcs/TATMappings/DtcEdit/context/context'
import CreateDtcForm from './antd/dtcs/TATMappings/DtcEdit/CreateDtcForm'
import TracerMapping from './antd/dtcs/TracerMapping'
import TracerMappingStore from './antd/dtcs/TracerMapping/context/context'
import TatConnectorMapping from './pages/vehicles/dtcs/TaTmappings/ConnectorMapping'
import MemoStore from './antd/dtcs/Memos/context/context'
import Memos from './antd/dtcs/Memos'
import FunctionalDiagramList from './antd/vehicle/functional_diagram'
import FunctionalDiagramStore from './antd/vehicle/functional_diagram/context/context'
import FunctionalDiagramEdit from './antd/vehicle/functional_diagram/edit_mapping/index'
import FunctionalDiagramEditStore from './antd/vehicle/functional_diagram/edit_mapping/context/context'

export default function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Layout Routes */}
        <Route path="/" element={
            <Store>
                <Layout />
            </Store>
        } key={'home'}>
            {/* Public Routes */}
            <Route path="users/sign_in" index element={<Login />} key={'login'} />
            <Route path={`auth/`} element={<Auth />} key={'auth'} />
            <Route path="not_permitted/" element={<NotPermitted />} key={'not_permitted'} />
            <Route path="logout_success/" element={<LogoutSuccess />} key={'logout_success'} />
          
            {/* Protected Routes */}
            <Route exact element={
                <VehicleProvider>
                    <PrivateRoute />
                </VehicleProvider>
            }>
                {/* Nested Routes */}
                <Route path="vehicles/" element={<Vehicles />} key={'vehicles'} />
                <Route path="vehicles/new" element={<CreateNewVehicle />} key={'vehicles_create'} />

                <Route path="vehicles/:vehicle" element={ <VehicleWorkspaceLayout /> } >
                  <Route path="importers" element={ <Importers /> } key={'vehicle_importers'} />
                  <Route path="edit_vehicle" element={<EditVehicle />} key={'vehicles_edit'} />
                  <Route path="csv_dependencies" element={<VehicleCSVDependencies />} key={'vehicles_edit'} />
                  <Route path="demo_payload" element={<DemoPayload />} key={'vehicles_edit'} />
                  {/* DTCs Submenu */}
                  <Route path={`dtcs/listing`} element={<TatStore><DtcsListing /></TatStore>} key={'dtc_listing'} />
                  <Route path={`dtcs/listing/:dtc_id/edit`} element={<DtcEdit />} key={'tat_dtc_edit'} />
                  <Route path={`dtcs/listing/:dtc_id/clone`} element={<DtcClone />} key={'tat_dtc_edit'} />
                  <Route path={`dtcs/listing/:dtc_id/add_dependency`} element={<DtcDependencyStore><DtcAddDependencies /></DtcDependencyStore>} key={'tat_dtc_edit'} />
                  <Route path={`dtcs/listing/new`} element={<CreateDtcForm />} key={'tat_dtc_new'} />
                  <Route path={`dtcs/listing/mappings`} element={<TatDtcMappings />} key={'tat_dtcs_mappings'} />
                  <Route path={`dtcs/listing/mappings/:connector_id`} element={<TatConnectorMapping />} key={'tat_dtcs_connector_mappings'} />

                  <Route path={`dtcs/tracer_mapping`} element={<TracerMappingStore><TracerMapping /></TracerMappingStore>} key={'dtc_tracer_mapping'} />
                  <Route path={`dtcs/memos`} element={<MemoStore><Memos /></MemoStore>} key={'dtc_memos'} />
                  
                  <Route path={`connector_views`} element={<ConnectorViews />} key={'connector_views'} />
                  <Route path={`connector_views/new`} element={<ConnectorViewNew />} key={'connector_views_new'} />
                  <Route path={`connector_views/:connector_view/edit_mappings`} element={<ConnectorViewEditMappings />} key={'connector_views_edit_mappings'} />
                  <Route path={`connector_views/:connector_view/edit`} element={<ConnectorViewEdit />} key={'connector_views_edit'} />
                  <Route path={`connector_views/:connector_view/print`} element={<ConnectorViewMappingsPrintPage />} key={'connector_views_print'} />

                  <Route path={`power_distributions`} element={<PowerDistributions />} key={'power_distributions'} />
                  {/* Plugins submenu */}
                  <Route path={`plugins/sales_code_complexity`} element={<SalesCodeComplexityStore><SalesCodeComplexity /></SalesCodeComplexityStore>} key={'plugin_sales_code_complexity'} />
                  <Route path={`plugins/def`} element={<DefPluginStore><DefPlugin /></DefPluginStore>} key={'plugin_def'} />
                  <Route path={`plugins/capital_harness`} element={<CapitalHarnessStore><CapitalHarness /></CapitalHarnessStore>} key={'plugin_capital_harness'} />
                  
                  <Route path={`inlines`} element={<InlineConnectionStore><InlineConnectionList /></InlineConnectionStore>} key={'inlines'} />
                  <Route path={`modules`} element={<ModuleStore><ModuleList /></ModuleStore>} key={'modules'} />
                  <Route path={`devices`} element={<DeviceStore><DeviceList /></DeviceStore>} key={'devices'} />
                  <Route path={`inspection_points`} element={<InspectionPointsStore><InspectionPointsList /></InspectionPointsStore>} key={'inspection_points'} />
                  <Route path={`wire`} element={<WireStore><WireList /></WireStore>} key={'wires'} />
                  <Route path={`connector`} element={<ConnectorStore><ConnectorList /></ConnectorStore>} key={'connector'} />
                  <Route path={`sales_code`} element={<SalesCodeStore><SalesCodeList /></SalesCodeStore>} key={'sales_code'} />

                  <Route path={`functional-diagram`} element={<FunctionalDiagramStore><FunctionalDiagramList /></FunctionalDiagramStore>} key={'functional_diagram'} />
                  <Route path={`functional-diagram/:functional`} element={<FunctionalDiagramEditStore><FunctionalDiagramEdit /></FunctionalDiagramEditStore>} key={'functional_diagram_edit'} />

                  <Route path={`harnesses`} element={<HarnessStore><HarnessList /></HarnessStore>} key={'harnesses'} />
                  <Route path={`circuit`} element={<CircuitStore><CircuitList /></CircuitStore>} key={'circuit'} />
                  <Route path={`device_connections`} element={<DeviceConnectionStore><DeviceConnectionList /></DeviceConnectionStore>} key={'device_connections'} />
                  {/* Validation submenu */}
                  <Route path={`validation/dtc_mapping_validation`} element={<DtcMappingValidationStore><DtcMappingValidationList /></DtcMappingValidationStore>} key={'dtc_mapping_errors'} />
                  <Route path={`validation/graph_missing_images`} element={<GraphMissingImagesStore><GraphMissingImagesList /></GraphMissingImagesStore>} key={'graph_missing_images'} />

                  <Route path={`visual-aid`} element={<VisualAidStore><VisualAidList /></VisualAidStore>} key={'visual_aid'} />
                  <Route path="*" element={<NotFound />} key={'no_page'} />
                </Route>
                
                <Route path={`administration/`} element={<Administration />} key={'administration'} />
                <Route path={`system_and_sub_system/`} element={<SystemAndSubSystem />} key={'system_and_sub_system'} />
                <Route path={`customer_setup/`} element={<CustomerStore><Customer /></CustomerStore>} key={'customer_setup'} />
                <Route path={`usage_report/`} element={<UsageReportStore><UsageReport /></UsageReportStore>} key={'usage_report'} />

                <Route path={`manage-update-list/`} element={<PromoteChangesStore><PromoteChangesList /></PromoteChangesStore>} key={'manage_update_list'} />
                <Route path={`tracer/preview`} element={<TracerPreviewPage />} key={'tracer_preview'} />
                <Route path="*" element={<NotFound />} key={'no_page'} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
